<template>
    <div class="toolModal">
        <b-modal id="tool-modal" :no-close-on-backdrop="true" :no-close-on-esc="true" centered size="lg"
                 @hidden="resetTool">
            <template #modal-title>

                <span v-if="!tool.type" class="stepTitle">Site Tool - {{ steps[step].title }}</span>
                <span v-else class="stepTitle">{{ $t(tool.type + '_tool') }} - {{
                        steps[step][tool.type + "_title"]
                    }}</span>
                {{ step }} / {{ Object.keys(steps).length }}
            </template>

            <template v-if="step === 1">
                <div class="row mt-3">
                    <div class="col-8 offset-2">

                        <h6 class="mb-5">Select tool type</h6>
                        <b-button v-b-tooltip.hover class="btn-block mb-5" size="md" title="General tool"
                                  variant="primary" @click="changeToolType('custom'); jumpToStep(2);">General
                        </b-button>
                        <b-button class="btn-block" size="md" variant="primary"
                                  @click="changeToolType('firestop'); jumpToStep(2);">Firestop
                        </b-button>
                    </div>
                </div>
            </template>

            <template v-if="step === 2">
                <div class="row mt-5 flags">
                    <div :class="locale === 'fi' ? 'active' : ''" class="col-3 offset-2 flag flag-fi"
                         @click="locale = 'fi'">
                        {{ $t("Finnish") }}
                    </div>
                    <div :class="locale === 'en' ? 'active' : ''" class="col-3 offset-2 flag flag-other"
                         @click="locale = 'en'">
                        {{ $t("Other") }}
                    </div>
                </div>
            </template>


            <template v-if="step >= 3">
                <FireStop v-if="tool.type === 'firestop'" :locale="locale" :step="step" :tool.sync="tool"
                          v-on:jumpToStep="jumpToStep"></FireStop>
                <CustomTool v-else :locale="locale" :step="step" :tool.sync="tool"
                            v-on:jumpToStep="jumpToStep"></CustomTool>
            </template>

            <template #modal-footer="{ cancel, ok }">
                <b-button v-if="showPreviousButton" variant="danger" @click="previousStep">
                    <b-icon aria-hidden="true" icon="arrow-left"></b-icon>
                    Previous
                </b-button>

                <b-button @click="cancel">Cancel</b-button>
                <b-button v-if="showNextButton" variant="danger" @click="nextStep">
                    Next
                    <b-icon aria-hidden="true" icon="arrow-right"></b-icon>
                </b-button>
                <b-button v-if="showSaveButton" :disabled="!hasManagerPermission('site_tools.edit')" variant="danger"
                          @click="saveTool">Save
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>

import moment from 'moment';
import FireStop from "./FireStop";
import CustomTool from "./CustomTool";

export default {
    name: 'ToolModal',
    components: {CustomTool, FireStop},
    props: {
        editTool: {
            type: Object,
            required: false,
            default: null
        },
        step: {
            type: Number,
            required: true,
            default: null
        }
    },
    data() {
        return {
            tool: null,
            products: [],
            locale: 'en'

        }
    },
    computed: {
        showPreviousButton(){
            return this.step > 1;
        },
        showSaveButton(){
            if(this.tool.id !== null){
                return true;
            }

            if(this.tool.type === 'firestop'){
                return this.step === 9;
            }

            return this.step === 8;
        },
        showNextButton() {
            if(this.tool.type === 'firestop'){
                return this.step < 9 && this.step > 1;
            }

            return this.step < 8 && this.step > 1;
        },
        steps() {
            return {
                1: {
                    title: this.$t('Create new tool')
                },
                2: {
                    firestop_title: this.$t('Select Language / Region'),
                    custom_title: this.$t('Select Language / Region')
                },
                3: {
                    firestop_title: this.$t('Tool icon'),
                    custom_title: this.$t('Basic info')
                },
                4: {
                    firestop_title: this.$t('Basic info'),
                    custom_title: this.$t('Tool icon')
                },
                5: {
                    firestop_title: this.$t('Add details'),
                    custom_title: this.$t('Functions'),
                },
                6: {
                    firestop_title: this.$t('Add products'),
                    custom_title: this.$t('Functions')
                },
                7: {
                    firestop_title: this.$t('Tool status'),
                    custom_title: this.$t('Tool status')
                },
                8: {
                    firestop_title: this.$t('Custom inputs'),
                    custom_title: this.$t('Summary'),
                },
                9: {
                    firestop_title: this.$t('Summary'),
                    custom_title: null,
                },
            };
        },
        defaultTool() {
            return {
                id: null,
                long_name: '',
                short_name: '',
                description: '',
                icon: 'custom',
                type: '',
                color: '#1D1D1B',
                show_upper_detail: true,
                show_lower_detail: true,
                show_running_number: true,
                created_at: moment().toISOString(),
                has_images: true,
                language: this.locale,

                has_catalogs: false,
                catalog_1: null,
                catalog_1_values: null,
                catalog_2: null,
                catalog_2_values: [''],
                catalog_3: null,
                catalog_3_values: null,
                catalog_4: null,
                catalog_4_values: null,
                catalog_5: null,
                catalog_5_values: [],
                catalog_6: null,
                catalog_6_values: [],
                catalog_7: null,
                catalog_7_values: [],
                catalog_8: null,
                catalog_8_values: [],
                catalog_9: null,
                catalog_9_values: [],
                catalog_10: null,
                catalog_10_values: [],
                catalog_11: null,
                catalog_11_values: [],
                catalog_12: null,
                catalog_12_values: [],
                catalog_13: null,
                catalog_13_values: [],
                catalog_14: null,
                catalog_14_values: [],
                catalog_15: null,
                catalog_15_values: [],
                catalog_16: null,
                catalog_16_values: [],
                catalog_17: null,
                catalog_17_values: [],
                catalog_18: null,
                catalog_18_values: [],
                catalog_19: null,
                catalog_19_values: [],
                catalog_20: null,
                catalog_20_values: [],

                has_text_boxes: false,
                text_1: null,
                text_2: null,
                text_3: null,
                text_4: null,
                text_5: null,
                text_6: null,
                text_7: null,
                text_8: null,
                text_9: null,
                text_10: null,
                text_11: null,
                text_12: null,
                text_13: null,
                text_14: null,
                text_15: null,
                text_16: null,
                text_17: null,
                text_18: null,
                text_19: null,
                text_20: null
            };
        }
    },
    mounted() {
        this.$i18n.locale = this.locale;
    },
    methods: {
        resetTool() {
            this.tool = _.cloneDeep(this.defaultTool);
            this.$emit('closeModal');
        },
        nextStep() {
            this.$emit('nextStep');
        },
        jumpToStep(step) {
            this.$emit('jumpToStep', step);
        },
        previousStep() {
            this.$emit('previousStep');
        },
        saveTool() {
            this.tool.language = this.locale;
            this.$emit('saveTool', this.tool);
        },
        changeToolType(type) {
            if (this.tool.type !== type) {
                this.tool = _.cloneDeep(this.defaultTool);
                this.tool.type = type;
                this.tool.language = this.locale;
            }

        }


    },
    watch: {
        'editTool': function (newTool) {
            if (newTool !== null && newTool) {
                this.tool = _.cloneDeep(newTool);
                this.locale = this.tool.language ?? 'en';
            } else {
                this.tool = _.cloneDeep(this.defaultTool);
                this.tool.language = this.locale;

            }
        },
        locale(val) {
            this.$i18n.locale = val;
            this.tool.language = val;
        }
    },
}
</script>
